/**
 * @generated SignedSource<<3f83c49d4ccb80b10d5e1d89129feb28>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type StorecastDeviceScheduleItemWeekday = "FRIDAY" | "MONDAY" | "SATURDAY" | "SUNDAY" | "THURSDAY" | "TUESDAY" | "WEDNESDAY";
export type StorecastScreenAdminAddScheduleItemQuery$variables = {
  screenId: string;
};
export type StorecastScreenAdminAddScheduleItemQuery$data = {
  readonly store: {
    readonly dashboards: ReadonlyArray<{
      readonly id: string;
      readonly name: string;
    }>;
  };
  readonly storecast: {
    readonly screen: {
      readonly id: string;
      readonly scheduledStorecasts: ReadonlyArray<{
        readonly endAt: string;
        readonly id: string;
        readonly startAt: string;
        readonly storecast: {
          readonly id: string;
        } | null;
        readonly weekdays: ReadonlyArray<StorecastDeviceScheduleItemWeekday>;
      }>;
    };
  };
};
export type StorecastScreenAdminAddScheduleItemQuery = {
  response: StorecastScreenAdminAddScheduleItemQuery$data;
  variables: StorecastScreenAdminAddScheduleItemQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "screenId"
  }
],
v1 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v2 = {
  "alias": null,
  "args": null,
  "concreteType": "Dashboard",
  "kind": "LinkedField",
  "name": "dashboards",
  "plural": true,
  "selections": [
    (v1/*: any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "name",
      "storageKey": null
    }
  ],
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "concreteType": "Storecast",
  "kind": "LinkedField",
  "name": "storecast",
  "plural": false,
  "selections": [
    {
      "alias": null,
      "args": [
        {
          "kind": "Variable",
          "name": "id",
          "variableName": "screenId"
        }
      ],
      "concreteType": "StorecastScreen",
      "kind": "LinkedField",
      "name": "screen",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "StorecastDeviceSetDashboardScheduleItem",
          "kind": "LinkedField",
          "name": "scheduledStorecasts",
          "plural": true,
          "selections": [
            (v1/*: any*/),
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "startAt",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "endAt",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "concreteType": "Dashboard",
              "kind": "LinkedField",
              "name": "storecast",
              "plural": false,
              "selections": [
                (v1/*: any*/)
              ],
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "weekdays",
              "storageKey": null
            }
          ],
          "storageKey": null
        },
        (v1/*: any*/)
      ],
      "storageKey": null
    }
  ],
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "StorecastScreenAdminAddScheduleItemQuery",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "Store",
        "kind": "LinkedField",
        "name": "store",
        "plural": false,
        "selections": [
          (v2/*: any*/)
        ],
        "storageKey": null
      },
      (v3/*: any*/)
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "StorecastScreenAdminAddScheduleItemQuery",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "Store",
        "kind": "LinkedField",
        "name": "store",
        "plural": false,
        "selections": [
          (v2/*: any*/),
          (v1/*: any*/)
        ],
        "storageKey": null
      },
      (v3/*: any*/)
    ]
  },
  "params": {
    "cacheID": "fb672d81f275e8d6342646e675342432",
    "id": null,
    "metadata": {},
    "name": "StorecastScreenAdminAddScheduleItemQuery",
    "operationKind": "query",
    "text": "query StorecastScreenAdminAddScheduleItemQuery(\n  $screenId: ID!\n) {\n  store {\n    dashboards {\n      id\n      name\n    }\n    id\n  }\n  storecast {\n    screen(id: $screenId) {\n      scheduledStorecasts {\n        id\n        startAt\n        endAt\n        storecast {\n          id\n        }\n        weekdays\n      }\n      id\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "f27f3a74e2ebcb98606816ee30b5dbd8";

export default node;
